import './notfound.css'

import {
	IonContent,
	IonPage,
} from '@ionic/react'
import React from 'react'

const NotFound = () => {
	return (
		<IonPage>
			<IonContent className="ion-padding">
				<div className="not-found">
					<h1>Page Not Found</h1>
					<p>
						AutoRoster couldn't find that page.
					</p>
				</div>
			</IonContent>
		</IonPage>
	)
}

export default NotFound
